import { connect } from "react-redux";
import { isRequestActive } from "redux-request-loading";

import { partiallyMatchedEmployeeSelector } from "../common/selectors";
import {
    matchSraToNewEmployeeRecord,
    matchSraToEmployeeRecord,
    rerunPartiallyMatchedSraDetail,
    loadPartiallyMatchedSraDetail } from "../stressRiskAssessment/actions";
import { PartiallyMatchedEmployeeAppState } from "../common/model";
import { MATCH_SRA_TO_EMPLOYEE_RECORD, MATCH_SRA_TO_NEW_EMPLOYEE_RECORD, RERUN_PARTIALL_MATCHED_SRA_DETAIL } from "../stressRiskAssessment/actionTypes";

import { Detail, DetailDispatchProps, DetailProps } from "./Detail";

function mapStateToProps(state: PartiallyMatchedEmployeeAppState): DetailProps {
    return {
        partiallyMatchedEmployee: partiallyMatchedEmployeeSelector(state),
        title: "Stress Risk Assessment",
        moreRoute: "",
        isSubmitting: isRequestActive(state, MATCH_SRA_TO_EMPLOYEE_RECORD)
            || isRequestActive(state, MATCH_SRA_TO_NEW_EMPLOYEE_RECORD)
            || isRequestActive(state, RERUN_PARTIALL_MATCHED_SRA_DETAIL),
        referralId: state.router.params.referralId,
        customerId: state.router.params.customerId
    };
}

function mapDispatchToProps(dispatch: any): DetailDispatchProps {
    return {
        matchEmployeeToNewEmployeeRecord: (customerId: string, referralId: string) =>
            dispatch(matchSraToNewEmployeeRecord(customerId, referralId)),
        matchToEmployeeRecord: (formCustomerId: string, referralId: string, employeeRecordCustomerId: string, employeeRecordId: string) =>
            dispatch(matchSraToEmployeeRecord(formCustomerId, referralId, employeeRecordCustomerId, employeeRecordId)),
        rerunEmployeeMatching: (customerId: string, referralId: string) =>
            dispatch(rerunPartiallyMatchedSraDetail(customerId, referralId)),
        loadPartiallyMatchedDetails: (customerId: string, referralId: string) => dispatch(loadPartiallyMatchedSraDetail({ customerId, referralId }))
    };
}

export const SraDetail = connect(mapStateToProps, mapDispatchToProps)(Detail);
